import { Injectable, Logger } from '@nestjs/common';
import { cert, App as FirebaseApp, initializeApp } from 'firebase-admin/app';
import {
  BatchResponse,
  getMessaging,
  MulticastMessage,
} from 'firebase-admin/messaging';

@Injectable()
export class FirebaseService {
  private firebaseApp: FirebaseApp;
  private readonly logger = new Logger(FirebaseService.name);

  constructor() {
    if (
      !process.env.FIREBASE_PROJECT_ID ||
      !process.env.FIREBASE_PRIVATE_KEY ||
      !process.env.FIREBASE_CLIENT_EMAIL
    ) {
      throw new Error(
        'Firebase credentials are not set in environment variables',
      );
    }

    const firebaseConfig = {
      projectId: process.env.FIREBASE_PROJECT_ID,
      privateKey: process.env.FIREBASE_PRIVATE_KEY.replace(/\\n/g, '\n'),
      clientEmail: process.env.FIREBASE_CLIENT_EMAIL,
    };
    this.firebaseApp = initializeApp({
      credential: cert(firebaseConfig),
    });
  }

  async sendMessageToDevices(
    tokens: string[],
    title: string,
    body: string,
    data: Record<string, any> = {},
    badge: number | null = null,
    webLink: string | null = null,
    noNotificationObject: boolean = false,
  ): Promise<BatchResponse | null> {
    if (!Array.isArray(tokens) || !tokens.length) {
      return null;
    }

    const messageData: MulticastMessage = {
      tokens,
      ...(!noNotificationObject && {
        notification: {
          title,
          body,
        },
      }),
      data: {
        title: title,
        body: body,
        ...data,
      },
      android: {
        notification: {
          notificationCount: badge || undefined,
          priority: 'high',
        },
      },
      apns: {
        payload: {
          aps: {
            badge: badge || undefined,
            sound: 'default',
          },
        },
      },
      webpush: {
        fcmOptions: {
          link: webLink || undefined,
        },
      },
    };

    let response: BatchResponse | null = null;
    try {
      response = await getMessaging(this.firebaseApp).sendEachForMulticast(
        messageData,
      );
      this.logger.log('FCM notification sent successfully', response);
    } catch (error) {
      this.logger.error('FCM notification error:', error);
    }

    return response;
  }
}
